module.exports = __webpack_public_path__ + "img/H03098-01.2261a5cf.jpg";